import React from 'react';
import CardSlot from '../parts/CardSlot';
import styled, { keyframes } from 'styled-components';
import colors from 'theme/colors';
import fonts from 'theme/fonts';
import { formatPostalcodel } from 'helpers/postalcode';
import { MapPin } from 'react-feather';

export default function ProfileAddress({ data }) {

  const fields = [
    { label: 'Bairro', value: data?.district },
    { label: 'Rua', value: data?.name },
    { label: 'CEP', value: formatPostalcodel(data?.postalcode) },
    { label: 'Número', value: data?.number },
    ...(data?.complement ? [{ label: 'Complemento', value: data?.complement }] : []),
  ];

  return (
    <CardSlot marginTop={'10px'}>
      <Header>
        <IconBox>
          <MapPin size={18} color={colors.neutralLight} />
        </IconBox>
        <HeaderText>
          <Title>Endereço</Title>
          <Subtitle>Localização do estabelecimento</Subtitle>
        </HeaderText>
      </Header>

      <AddressList>
        {fields.map((field, i) => (
          <AddressRow key={field.label} index={i}>
            <AddressLabel>{field.label}</AddressLabel>
            <AddressDots />
            <AddressValue>{field.value || '—'}</AddressValue>
          </AddressRow>
        ))}
      </AddressList>
    </CardSlot>
  );
}

const fadeSlideUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
`;

const IconBox = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: linear-gradient(135deg, ${colors.primaryLight}, ${colors.primary});
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 3px 10px rgba(63, 107, 198, 0.25);
`;

const HeaderText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const Title = styled.h3`
  font-size: ${fonts.sizes.highlight};
  font-weight: ${fonts.weight.bold};
  color: ${colors.nightDark};
  margin: 0;
  line-height: 1.2;
`;

const Subtitle = styled.p`
  font-size: ${fonts.sizes.small};
  color: ${colors.night};
  margin: 0;
`;

const AddressList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const AddressRow = styled.div`
  display: flex;
  align-items: baseline;
  padding: 10px 14px;
  border-radius: 10px;
  gap: 8px;
  animation: ${fadeSlideUp} 0.35s ease forwards;
  animation-delay: ${({ index }) => index * 0.05}s;
  opacity: 0;

  &:nth-child(odd) {
    background: rgba(0, 0, 0, 0.015);
  }
`;

const AddressLabel = styled.span`
  font-size: ${fonts.sizes.default};
  font-weight: ${fonts.weight.bold};
  color: ${colors.nightDark};
  flex-shrink: 0;
  white-space: nowrap;
`;

const AddressDots = styled.span`
  flex: 1;
  border-bottom: 1px dashed rgba(0, 0, 0, 0.1);
  min-width: 20px;
  margin-bottom: 3px;
`;

const AddressValue = styled.span`
  font-size: ${fonts.sizes.default};
  color: ${colors.night};
  text-align: right;
  word-break: break-word;
`;
